<template>
  <div>
    <div class="columns is-gapless is-vcentered is-border-bottom has-bg-light is-min-height-50">
      <div class="column is-padding-left is-padding-right">
        <span class="is-size-6">{{users.length}} Utilisateur<span v-if="users && users.length > 1">s</span></span>
      </div>
      <div class="column is-narrow is-border-left is-self-stretched">
        <router-link :to="{name: 'UserCreate', query: {company: company.pk}}"
          class="button is-min-width-0 is-radiusless is-small is-light is-min-height-full has-text-grey">
          <span class="icon is-small has-text-grey"><i class="fas fa-user-plus"></i></span>
          <span>Ajouter un utilisateur</span>
        </router-link>
      </div>
    </div>
    <table class="table is-hoverable is-fullwidth is-last-fixed-small is-marginless-bottom" v-if="users && users.length">
      <thead>
      <tr class="is-size-6">
        <th><span>Membres</span></th>
        <th><span>Email</span></th>
        <th><span>Rôle</span></th>
        <th></th>
      </tr>
      </thead>
      <tbody class="is-size-5 has-text-text">
      <tr v-for="(user, i) in users" :key="i" class="is-size-6">
        <td>
          <router-link :to="{name: 'UserVue', params: {id: user.pk}}">
            <avatar :item="user" :i="i"></avatar>
            <span class="is-inline-flex is-margin-left-xsmall">{{user.first_name}} {{user.last_name}}</span>
          </router-link>
        </td>
        <td>{{user.email}}</td>
        <td>{{user.profil_type | profilTypeLabel}}</td>
        <td class="has-text-right actions">
          <display-button-list :forceDropDown="true" :buttons="buttonList" :data="user">
          </display-button-list>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="column" v-else>Aucun utilisateur à afficher</div>
  </div>
</template>

<script>
  import { DefaultValues, GenericList } from '../../../mixins'
  import { mapGetters } from 'vuex'

  export default {
    name: 'UserPanel',
    mixins: [DefaultValues, GenericList],
    props: {
      company: {
        required: true,
        type: Object
      }
    },
    components: {},
    data () {
      return {
        service: this.$api.userService,
        items: [],
        buttonList: [
          {
            routeName: 'UserVue',
            icon: 'fa-eye',
            text: 'Voir'
          },
          {
            routeName: 'UserEdit',
            icon: 'fa-edit',
            text: 'Editer',
            needProfile: ['admin', 'manager', 'manager_ext']
          },
          {
            action: (id) => {
              this.deleteItem(id)
            },
            display: (adv) => {
              return this.isAdmin
            },
            icon: 'fa-trash',
            text: 'Supprimer',
            needProfile: ['admin', 'manager', 'manager_ext']
          }
        ]
      }
    },
    computed: {
      ...mapGetters(['isAdmin', 'isManager', 'currentUserPk']),
      companyPk () {
        return this.company.pk
      },
      users () {
        return this.items
      }
    },
    methods: {
      getUsers () {
        this.loading = true
        let query = {
          company: this.companyPk,
          per_page: 100,
          sort: 'first_name:asc'
        }
        this.$api.userService.get(query).then(r => {
          this.loading = false
          this.items = r.data.items
        })
      }
    },
    created () {
      this.getUsers()
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/company/CompanyVuePanels/UserPanel.vue